import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgArrowRight = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99947 20.3009C9.99947 19.8341 10.1995 19.402 10.5329 19.0686L16.0011 14.0005H4.00053C2.80021 14.0005 2 13.2003 2 12C2 10.7997 2.80021 10.0021 4.00053 10.0021H16.0011L10.4663 4.86743C10.1648 4.56869 9.99947 4.10189 9.99947 3.69912C9.99947 2.76821 10.8664 2 11.7333 2C12.2001 2 12.6322 2.20005 12.9336 2.50147L21.3998 10.7997C21.7333 11.1331 22 11.5332 22 12C22 12.4348 21.7013 12.9016 21.3998 13.2003L12.9656 21.4665C12.5655 21.8666 12.1334 22 11.7333 22C10.7677 22 9.99947 21.2345 9.99947 20.3009Z", fill: props.fill }));
});
export default SvgArrowRight;
